import { AvailableLanguages, availableLanguages } from '@shared/types/translation.type';

/**
 * Maps a BCP 47 tag (browser, Keycloak or saved preference) onto a supported language.
 * An exact match wins; otherwise the primary subtag decides, so `pt` and `pt-PT` both land on
 * `pt-BR` while `es-MX` lands on `es`. Cutting the tag at its first hyphen instead would turn
 * `pt-BR` into `pt` and never match.
 */
export function resolveLanguage(
  tag: string | null | undefined
): AvailableLanguages | undefined {
  if (!tag) return undefined;
  // Keycloak and Java locales spell the region with an underscore (`pt_BR`).
  const normalized = tag.toLowerCase().replace('_', '-');
  const exact = availableLanguages.find((lang) => lang.toLowerCase() === normalized);
  if (exact) return exact;
  const primary = normalized.split('-')[0];
  return availableLanguages.find((lang) => lang.toLowerCase().split('-')[0] === primary);
}
